import { identityBasePart } from "./constants";

export default {
  individualAssignment: (projectId: string) =>
    `${identityBasePart}/project/${projectId}/individual-assignment`,
  all: (projectId: string) =>
    `${identityBasePart}/project/${projectId}/members-details`,
};
